<div id="dashboard" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center sm:w-auto">
      <div class="flex sm:justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Lease Documents</div>
      <div class="grid grid-rows-2 sm:justify-items-center mt-2 px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl">
        <div>Below please find your executed leases with Tricon.</div>
        <div>Thank you for your residency with us.</div>
      </div>
    </div>
  </div>
  <div *ngIf="errorMessage!=null" class="alert alert-danger text-center">
    {{ errorMessage }}
  </div>
  <div class="sm:w-auto flex justify-center border-0">
    <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-8">
      <div *ngFor="let lease of leases">
        <div *ngIf="!lease.DefaultCard && lease.PropViewCard?.sqft != null" class="my-4 flex justify-center flex-col">
          <div *ngIf="!lease.DefaultCard">
            <img class="rounded w-full h-auto max-w-500px" src={{lease.PropViewCard.thumb}}>
          </div>
          <div class="flex flex-row justify-between items-baseline">
            <div *ngIf="!lease.DefaultCard" class="flex text-2xl font-bold items-baseline">
              ${{lease.RentAmount}} <span class="text-base text-gray-tricon ml-1">/mo</span>
            </div>
            <div class="flex flex-row justify-evenly text-lg">
              <div *ngIf="!lease.DefaultCard" class="flex text-black">{{lease.PropViewCard.beds}}<span
                  class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
              <div *ngIf="!lease.DefaultCard" class="flex ml-1 text-black">{{lease.PropViewCard.baths}}<span
                  class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon">|</span></div>
              <div *ngIf="!lease.DefaultCard" class="flex ml-1 text-black">{{lease.PropViewCard?.sqft}}<span
                  class="text-gray-tricon ml-1">sqft</span></div>
            </div>
          </div>
          <div *ngIf="!lease.DefaultCard" class="text-2xl sm:text-lg pb-4 border-b border-solid border-gray-400">
            {{lease.AddressLine1}} {{lease.City}}, {{lease.State}} {{lease.PropViewCard.zip}}
          </div>
          <div class="flex flex-col mt-4">
            <div class="flex flex-row justify-between mb-1">
              <div class="text-2xl sm:text-lg text-gray-tricon">
                Lease Start Date:
              </div>
              <div class="text-2xl sm:text-lg font-bold">
                {{lease.StartDateString}}
              </div>
            </div>
            <div class="flex flex-row justify-between mt-1">
              <div class="text-2xl sm:text-lg text-gray-tricon">
                Lease End Date:
              </div>
              <div class="text-2xl sm:text-lg font-bold">
                {{lease.EndDateString}}
              </div>
            </div>
          </div>
          <button *ngIf="!lease.DefaultCard" mat-flat-button color="accent" class="my-4 sm:text-base"
            (click)="downloadAndOpenLease(lease)">VIEW LEASE</button>
        </div>
        <div *ngIf="lease.DefaultCard" class="my-4 flex flex-col">
          <div>
            <img class="rounded w-full h-auto  max-w-500px" src="../../../assets/images/FallbackImage_House.jpg">
          </div>
          <button mat-flat-button color="primary" [disabled]="lease.PropViewCard.sqft == null"
            class="my-4 sm:text-base">NO LEASES</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="hoaDocuments.length > 0">
    <div class="flex flex-col justify-center sm:w-auto">
      <div class="mb-8 flex flex-col justify-center sm:w-auto">
        <div class="flex sm:justify-center text-3xl sm:text-40px mt-6">HOA Documents</div>
        <div class="grid grid-rows-2 sm:justify-items-center mt-2 px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl">
          <div>Below please find the HOA documents for your home.</div>
        </div>
      </div>
    </div>
    <div class="sm:w-auto flex justify-center border-0">
      <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-8">
        <div *ngFor="let doc of hoaDocuments">
          <div class="my-4 flex justify-center flex-col">
            <img class="rounded w-full h-auto max-w-500px" src={{doc.imageUrl}}>
            <div class="flex flex-row justify-between items-baseline">
              <div class="flex text-2xl font-bold items-baseline">
                {{doc.hoaName}}
              </div>
            </div>
            <div class="flex flex-row text-lg">
              <div class="text-gray-tricon">Updated {{ doc.getDate() }}</div>
            </div>
            <div class="text-2xl sm:text-lg pb-4 border-b border-solid border-gray-400">
              {{ doc.title }}
            </div>
            <button mat-flat-button color="accent" class="my-4 sm:text-base"
              (click)="openNewTab(doc.url)">VIEW HOA DOCUMENT</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
